// extracted by mini-css-extract-plugin
module.exports = {"month":"_15Gs1","sr-only":"_2h7wt","srOnly":"_2h7wt","text":"_2Q4lx","disabled":"_7d234","today":"C978C","selected":"-wiJs"};